import { formatSecondsDuration } from 'helpers'
import { connect } from 'react-redux'
import Helmet from './Helmet'

const mapStateToProps = ({ learningPath }) => {
  const title = learningPath?.LearningPath?.Title || ''
  const subtitle = learningPath?.LearningPath?.Subtitle || ''
  const categories = learningPath?.LearningPath?.Categories.length ? learningPath.LearningPath.Categories : ''
  const duration = learningPath?.LearningPath?.Duration ? formatSecondsDuration(learningPath.LearningPath.Duration) : ''
  const image = learningPath.LearningPath?.Image ? learningPath.LearningPath.Image : ''
  const slug = learningPath.LearningPath?.Slug ? learningPath.LearningPath.Slug : ''
  const metaTitle = learningPath?.LearningPath?.MetaTitle || ''
  const metaDescription = learningPath?.LearningPath?.MetaDescription || ''
  const Courses = learningPath?.Courses?.Data || []
  return {
    title,
    subtitle,
    categories,
    duration,
    image,
    slug,
    metaTitle,
    metaDescription,
    Courses
  }
}

export default connect(mapStateToProps, null)(Helmet)
